import { jsx as _jsx } from "react/jsx-runtime";
import { ConstructionIcon, EnterpriseIcon, HrIcon, ItIcon, MarketingIcon, MediaIcon, OperationsIcon, PmoIcon, ProductIcon, RetailIcon, RndIcon, SalesIcon, SmbIcon } from "./icons/index.js";
import { CONSTRUCTION_MINI_SITE_LINK, CRM_MINI_SITE_LINK, ENTERPRISE_PAGE_LINK, HR_USE_CASES_LINK, MEDIA_PAGE_LINK, OPERATIONS_CLUSTER_LINK, RETAIL_PAGE_LINK, SERVICE_MINI_SITE_LINK, SMB_PAGE_LINK, SOFTWARE_MINI_SITE_LINK, WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK, WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK } from "constants/links";
export const COMPANY_SIZE_LINKS = [
    {
        icon: /*#__PURE__*/ _jsx(EnterpriseIcon, {}),
        title: "Enterprise",
        link: ENTERPRISE_PAGE_LINK,
        description: "Gain visibility and control at scale"
    },
    {
        icon: /*#__PURE__*/ _jsx(SmbIcon, {}),
        title: "SMB",
        link: SMB_PAGE_LINK,
        description: "Run your entire business in one place"
    }
];
export const TEAMS_LINKS = [
    {
        icon: /*#__PURE__*/ _jsx(MarketingIcon, {}),
        text: "Marketing",
        link: WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(SalesIcon, {}),
        text: "Sales",
        link: CRM_MINI_SITE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(ProductIcon, {}),
        text: "Product",
        link: SOFTWARE_MINI_SITE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(RndIcon, {}),
        text: "R&D",
        link: SOFTWARE_MINI_SITE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(PmoIcon, {}),
        text: "PMO",
        link: WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(OperationsIcon, {}),
        text: "Operations",
        link: OPERATIONS_CLUSTER_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(ItIcon, {}),
        text: "IT",
        link: SERVICE_MINI_SITE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(HrIcon, {}),
        text: "HR",
        link: HR_USE_CASES_LINK
    }
];
export const INDUSTRIES_LINKS = [
    {
        icon: /*#__PURE__*/ _jsx(RetailIcon, {}),
        text: "Retail",
        links: RETAIL_PAGE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(MediaIcon, {}),
        text: "Media",
        links: MEDIA_PAGE_LINK
    },
    {
        icon: /*#__PURE__*/ _jsx(ConstructionIcon, {}),
        text: "Construction",
        links: CONSTRUCTION_MINI_SITE_LINK
    }
];
